'use strict';

module.exports = {
    filterMetadataPath: '',
    filterStatusPath: '',

    updateFilterStatus(ev, newFilterStatus, isResetRequested) {
        ev.stopPropagation();
        // We receive values from server representing the new amount of hotels that satisfy the filter action.
        // If it's different from the values we already have, a view refresh is launched.
        this.resetModel(isResetRequested);
        this.set(Odigeo._.extend(
            Odigeo._.get(newFilterStatus, this.filterMetadataPath),
            Odigeo._.get(newFilterStatus, this.filterStatusPath),
            {isResetRequested}
        ));
    },

    resetModel(isResetRequested) {
        if (isResetRequested) {
            this.clear({silent: true});
        }
    },

    hasItems() {
        return Odigeo._.size(this.get('items')) > 0;
    },

    hasSelectedItem(item) {
        return Odigeo._.isArray(this.get('selectedItems')) &&
            Odigeo._.findIndex(this.get('selectedItems'), (selectedItem) => selectedItem.toString() === item.toString()) !== -1;
    },
};
